<template>
  <div class="contenido">
    <v-card class="elevation-6" style="opacity:0.8;">
      <v-card-text>
        <v-layout row wrap class="my-2">
          <v-tooltip color="primary" top>
            <template v-slot:activator='{ on }'>
              <v-icon v-on='on' color="primary" x-large @click="$root.$emit('onOpcionPortal', 'principal')">keyboard_backspace</v-icon>
            </template>
            <span>Ir atrás</span>
          </v-tooltip>
          <v-spacer/>
          <span class="primary--text">
            <h3><v-icon class="my-1" color="primary">help</v-icon>&nbsp;Manuales</h3>
          </span>
          <v-spacer/>
        </v-layout>
        <v-layout row wrap>
          <v-flex xs12>
            <span class="black--text">
              ¿Necesita más ayuda?
            </span><br>
            <span class="black--text">
              <a href="https://cloud.contraloria.gob.bo/nextcloud/index.php/s/qbxkg6tp56DseHo" target="_blank">Descargue el manual de usuario para la Declaración Jurada de Bienes y Rentas Tradicional.&nbsp;<v-icon>get_app</v-icon></a>
            </span><br>
            <span class="black--text">
              <a href="https://cloud.contraloria.gob.bo/nextcloud/index.php/s/mNnYJjxba47Zj5g" target="_blank">Descargue el manual de usuario para la Declaración Jurada de Bienes y Rentas Digital.&nbsp;<v-icon>get_app</v-icon></a>
            </span>
          </v-flex>
        </v-layout>
      </v-card-text>    
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'ayuda',
  data () {
    return {};
  },
  methods: {
    descargarArchivoPdf (dato) {
      let urlArchivo = '';
      let usuario = 'portal';
      let nombreUsuario = 'usuario_portal';
      switch (dato) {
        case 0: urlArchivo = 'archivo_predefinido/manual_djbrd_tradicional_externo';
          break;
        case 1: urlArchivo = 'archivo_predefinido/manual_djbrd_digital_externo';
          break;
      }
      this.$service.get(`${urlArchivo}/${usuario}/${nombreUsuario}`).then(response => {
        if (response) {
          this.downloadPDF(response.documento, response.nombre);
        }
      }).catch(e => {
        console.log(e);
      });
    },
    downloadPDF (pdf, name) {
      const url = window.URL.createObjectURL(this.b64toBlob(pdf, 'application/pdf'));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `${name}`);
      document.body.appendChild(link);
      link.click();
    },
    b64toBlob (b64Data, contentType, sliceSize) {
      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      let byteCharacters = atob(b64Data);
      let byteArrays = [];

      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        let slice = byteCharacters.slice(offset, offset + sliceSize);

        let byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        let byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }
      let blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }
  }
};
</script>
<style scoped>
.contenido {
  padding-right: 10%;
  padding-top: 2%;
  padding-left: 10%;
}
</style>


// WEBPACK FOOTER //
// src/components/djbrd/Manuales.vue